import { Component, Input } from '@angular/core';
import { AccountReview } from './accounts-information.models';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-account-review-card',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <div class="pb-6 border-b border-border-strong last:border-0">
      <div class="flex items-start gap-4">
        <img
          [src]="review.avatarUrl"
          [alt]="review.name.startsWith('accountsInformation.') ? (review.name | translate) : review.name"
          class="w-12 h-12 rounded-full object-cover"
        />
        <div class="flex-1">
          <div class="flex items-start justify-between mb-2">
            <div>
              <div class="text-text-primary">{{ review.name.startsWith('accountsInformation.') ? (review.name | translate) : review.name }}</div>
              <div class="text-sm text-text-secondary">
                {{ review.timeAgo.startsWith('accountsInformation.') ? (review.timeAgo | translate) : review.timeAgo }}
              </div>
            </div>
            <div class="flex items-center gap-1">
              @for (star of ratingStars; track star) {
                <i
                  class="fas fa-star text-sm"
                  [class.text-primary]="star <= review.rating"
                  [class.text-text-muted]="star > review.rating"
                ></i>
              }
            </div>
          </div>
          <p class="text-text-secondary mb-2 leading-relaxed">
            {{ review.comment.startsWith('accountsInformation.') ? (review.comment | translate) : review.comment }}
          </p>
          <div class="text-sm text-text-secondary flex items-center gap-1">
            <i class="fas fa-building"></i>
            {{ review.propertyName.startsWith('accountsInformation.') ? (review.propertyName | translate) : review.propertyName }}
          </div>
        </div>
      </div>
    </div>
  `,
})
export class AccountReviewCardComponent {
  @Input({ required: true }) review!: AccountReview;

  readonly ratingStars = [1, 2, 3, 4, 5];
}
